<script>
  import { tick } from 'svelte';
  import { urlParams } from '../base/store';
  const ORDER_BY = {
    // name: "По названию:",
    actual_price: "По цене",
  }
// Control variables
  $: active = key => (($urlParams['order_by'] || [])[0] || '').includes(key);
  $: directionDown = () => (($urlParams['order_by'] || [])[0] || '').includes('-');
  $: up = key => active(key) && !directionDown();
  $: down = key => active(key) && directionDown();
// Handler
  const handleClick = key => async e => {
    const orderBy = active(key)
      ? directionDown()
        ? null
        : '-' + key
      : key;
    orderBy
      ? urlParams.setParam('order_by', [orderBy])
      : urlParams.removeParam('order_by');
    urlParams.removeParam('page');
    await urlParams.applyFilters();
  }
</script>

{#each Object.entries(ORDER_BY) as [key, value]}
  <button class="sort-button"
    class:active={active(key)}
    class:down={active(key) && directionDown()}
    class:up={active(key) && !directionDown()}
    on:click={handleClick(key)}
>
    <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="15.5" cy="15.5" r="15.5" />
      <path d="M9 12H11.925H14.85" stroke="#181818" />
      <path d="M9 16H14.2H19.4" stroke="#181818" />
      <path d="M9 20H15.5H22" stroke="#181818" />
    </svg>
    <p>
      {value}{
        up(key)
        ? ': сначала дешевые'
        : down(key)
          ? ': сначала дорогие'
          : ''  
      }
    </p>
  </button>
{/each}
